// extracted by mini-css-extract-plugin
module.exports = {"container":"settings_container__3imzV","cardRoot":"settings_cardRoot__3Y2c5","rightContent":"settings_rightContent__1Pffj","right":"settings_right__qnCod"};